'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
/**
 * @deprecated use MetaRobots
 */

const RobotsMeta = ({
  name,
  noIndex,
  noFollow
}) => {
  const content = useMemo(() => {
    const values = [];
    if (noIndex) values.push('noindex');
    if (noFollow) values.push('nofollow');
    return values.join(',');
  }, [noFollow, noIndex]);

  if (!content) {
    return null;
  }

  return /*#__PURE__*/_jsx("meta", {
    name: name,
    content: content
  });
};

RobotsMeta.propTypes = {
  name: PropTypes.string,
  noFollow: PropTypes.bool,
  noIndex: PropTypes.bool
};
RobotsMeta.defaultProps = {
  name: 'robots'
};
export default RobotsMeta;